/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Register_Onboarding_Terms_Form_Accuracyconfirm_Label1Inputs */

const en_register_onboarding_terms_form_accuracyconfirm_label1 = /** @type {(inputs: Register_Onboarding_Terms_Form_Accuracyconfirm_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I confirm the accuracy of my information`)
};

const de_register_onboarding_terms_form_accuracyconfirm_label1 = /** @type {(inputs: Register_Onboarding_Terms_Form_Accuracyconfirm_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ich bestätige die Richtigkeit meiner Angaben`)
};

/**
* | output |
* | --- |
* | "I confirm the accuracy of my information" |
*
* @param {Register_Onboarding_Terms_Form_Accuracyconfirm_Label1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const register_onboarding_terms_form_accuracyconfirm_label1 = /** @type {((inputs?: Register_Onboarding_Terms_Form_Accuracyconfirm_Label1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Register_Onboarding_Terms_Form_Accuracyconfirm_Label1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_register_onboarding_terms_form_accuracyconfirm_label1(inputs)
	return en_register_onboarding_terms_form_accuracyconfirm_label1(inputs)
});
export { register_onboarding_terms_form_accuracyconfirm_label1 as "register_onboarding_terms_form_accuracyConfirm_label" }